/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EventValidator,
    EventValidatorFromJSON,
    EventValidatorFromJSONTyped,
    EventValidatorToJSON,
    PrerequisiteType,
    PrerequisiteTypeFromJSON,
    PrerequisiteTypeFromJSONTyped,
    PrerequisiteTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface Prerequisite
 */
export interface Prerequisite {
    /**
     * 
     * @type {PrerequisiteType}
     * @memberof Prerequisite
     */
    prerequisiteType: PrerequisiteType;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Prerequisite
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    nftGroupingId?: string;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    questId?: string;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    guildId?: string;
    /**
     * 
     * @type {EventValidator}
     * @memberof Prerequisite
     */
    event?: EventValidator;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    challengeId?: string;
}

export function PrerequisiteFromJSON(json: any): Prerequisite {
    return PrerequisiteFromJSONTyped(json, false);
}

export function PrerequisiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Prerequisite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prerequisiteType': PrerequisiteTypeFromJSON(json['prerequisiteType']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'nftGroupingId': !exists(json, 'nftGroupingId') ? undefined : json['nftGroupingId'],
        'questId': !exists(json, 'questId') ? undefined : json['questId'],
        'guildId': !exists(json, 'guildId') ? undefined : json['guildId'],
        'event': !exists(json, 'event') ? undefined : EventValidatorFromJSON(json['event']),
        'challengeId': !exists(json, 'challengeId') ? undefined : json['challengeId'],
    };
}

export function PrerequisiteToJSON(value?: Prerequisite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prerequisiteType': PrerequisiteTypeToJSON(value.prerequisiteType),
        'description': value.description,
        'amount': value.amount,
        'nftGroupingId': value.nftGroupingId,
        'questId': value.questId,
        'guildId': value.guildId,
        'event': EventValidatorToJSON(value.event),
        'challengeId': value.challengeId,
    };
}


